// extracted by mini-css-extract-plugin
module.exports = {"main":"zensen-crm-components-page-header-wrapper-grid-content-main","wide":"zensen-crm-components-page-header-wrapper-grid-content-wide"};